<template>
  <el-dialog @open="oepn" append-to-body :close-on-click-modal="false" class="center" :visible="visible" title="收取预交金" @close="cancel" width="35rem" top="10vh">
    <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="9rem">
    <el-row>
        <el-col style="text-align: center" :span="24">
          <el-form-item label="预交金额：" prop="amount">
            <el-input type="text" maxlength="6" v-model="detailValue.amount" placeholder="请输入预交金额" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center" :span="24">
          <el-form-item label="收款方式：" prop="payWay">
            <el-select class="" v-model="detailValue.payWay" placeholder="请选择收款方式" size="small">
              <el-option v-for="(item, index) in dict.PayWay" :key="index" :label="item.text" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center" :span="24" v-if="detailValue.payWay =='ZP'">
          <el-form-item label="支票号：" prop="zpNo">
            <el-input v-model="detailValue.zpNo" type="number" placeholder="请输入支票号" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center" :span="24" v-if="detailValue.payWay =='ZP'">
          <el-form-item label="开户行：" prop="zpBank">
            <el-input v-model="detailValue.zpBank" type="number" placeholder="请输入开户行" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
          <el-col style="text-align: center" :span="24">
          <el-form-item label="交款人：" prop="payerName">
            <el-input v-model="detailValue.payerName" maxlength="10" placeholder="请输入交款人" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center" :span="24">
          <el-form-item label="联系方式：" prop="payerPhone">
            <el-input v-model="detailValue.payerPhone" placeholder="请输入交款人联系方式" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center" :span="24">
          <el-form-item label="批准人：" prop="">
            <el-input v-model="detailValue.pzPerson" maxlength="10" placeholder="请输入批准人" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;" class="center">
        <el-button size="large" @click.native="$emit('update:visible', false)" class="w100">关闭</el-button>
        <el-button :loading="meta.loading" class="w100" @click="submit" type="primary" style="margin-left: 1rem" size="large">提交</el-button>
        <br/>
        <br/>
        <el-checkbox v-model="checked">打印凭据</el-checkbox>
        
        <br/>
        <br/>
    </el-row>
    </el-form>
    <payment :infoDetail="payParams" v-if="meta.showPayment" :visible.sync="meta.showPayment"  @closePay="$emit('update:visible', false)"></payment>

  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    payment: () => import("@/components/_com/payment.vue"),

  },
  props: {
    title: String,
    patient: Object,
    visible: Boolean,
  },
  data() {
    var checkFloat = (rule, value, callback) => {
      let frex = /^[0-9]+\.?[0-9]*$/;
      if (!value) return callback();
      if (!frex.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    
    var ValidatePhone = (rule, val, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;//手机号码
      var isMob= /^0?1[3|4|5|8][0-9]\d{8}$/;// 座机格式  区号之后用'-'隔开
      if(isMob.test(val)||isPhone.test(val)){
          callback();
      }
      else{
          callback(new Error("请输入正确的联系方式"));
      }
    }
    return {
      checked: false,
      condition: {},
      rules: {
        amount: [
          { required: true, message: "请输入预交金额", trigger: "blur" },
          { validator: checkFloat, trigger: "blur" },
        ],
        payWay: [
          { required: true, message: "请选择支付方式", trigger: "change" },
        ],
        zpNo: [{ required: true, message: "请输入支票号", trigger: "blur" }],
        zpBank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        payerName: [
          { required: true, message: "请输入交款人", trigger: "blur" },
        ],
        payerPhone: [
          { required: true, message: "请输入交款人联系方式", trigger: "blur" },
          { validator: ValidatePhone, trigger: "blur" },
        ],
      },
      detailValue:{},
      meta: {
        loading: false,
        showPayment: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "dict",
      ,
      "Enum",
      "dictEnum",
      "user",
      "permission",
    ]),
    nowTime() {
      return new Date(); //this.$utils.fmtDateTime(new Date())
    },
  },
  filters: {},
  watch: {},
  mounted() {},
  methods: {
    oepn(){
      this.detailValue = {}
    },
    cancel() {
      clearTimeout(this.timer);
      this.$emit("update:visible", false);
    },
    submit(){
      this.$refs.info.validate((valid) => {
        if (valid) {
          
            let params = {
              ipNo:this.patient.ipNo,
              patientCode:this.patient.patientCode,
              patientName:this.patient.patientName,
              amount:this.detailValue.amount,
              payWay:this.detailValue.payWay,
              payerName:this.detailValue.payerName,
              payerPhone:this.detailValue.payerPhone,
              paymentType:0,//0-收费，1-退费
              occasion:0,//0-入院缴费、1-在院补缴、2-离院补缴，3-离院退费

              paymentId:1,
              paymentDate:'2022-06-22 12:00:00',
              printCheck:this.checked
            }
            this.payParams = params
            this.meta.showPayment = true
         
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    }
    
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timer);
    return next();
  },
};
</script>

<style scoped></style>
